define('pwa/plugin/multiple-booking/view/MultipleBookingCounterView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Multiple booking counter view
     *
     * @class MultipleBookingCounterView
     */
    return LayoutView.extend({

        template: '#multiple_booking_popup_list_view',
        collectionEvents: {
            reset: 'render',
            remove: 'render',
            add: 'render'
        },

        serializeData: function () {
            var result = {};
            result.count = this.collection.length;

            return result;
        }

    });

});
